import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, tuple_type, record_type, bool_type, int32_type, union_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Product$reflection } from "../../DomainTypes.js";
import { GlobalDependencies$reflection } from "../../Global.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";

export class EditGeneralTableEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeName", "OnChangeProduct", "OnChangePriceList", "OnChangeStatus", "OnChangeNetworkContractNr", "OnChangeContractTypePriceId", "EditGeneralTable", "SaveGeneralTable", "CancelGeneralTable"];
    }
}

export function EditGeneralTableEvent$reflection() {
    return union_type("Containers.ContractTypeGeneral.Model.EditGeneralTableEvent", [], EditGeneralTableEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", option_type(string_type)]], [["Item", option_type(string_type)]], [], [], []]);
}

export class Mortgage extends Record {
    constructor(ContractValuationId, Description, ValuationMissing, ContractTypeMortgageId) {
        super();
        this.ContractValuationId = ContractValuationId;
        this.Description = Description;
        this.ValuationMissing = ValuationMissing;
        this.ContractTypeMortgageId = ContractTypeMortgageId;
    }
}

export function Mortgage$reflection() {
    return record_type("Containers.ContractTypeGeneral.Model.Mortgage", [], Mortgage, () => [["ContractValuationId", option_type(int32_type)], ["Description", option_type(string_type)], ["ValuationMissing", bool_type], ["ContractTypeMortgageId", option_type(int32_type)]]);
}

export class ContractTypeGeneral extends Record {
    constructor(Active, ContractTypeCode, Display, Mortgage, NContracts, NetworkContractNr, PriceListCode, ProductNr, ShowDisplayOnInvoice, ContractTypePriceId, MainFeeTemplateNr, ReplaceWithContractTypeCode) {
        super();
        this.Active = Active;
        this.ContractTypeCode = ContractTypeCode;
        this.Display = Display;
        this.Mortgage = Mortgage;
        this.NContracts = (NContracts | 0);
        this.NetworkContractNr = NetworkContractNr;
        this.PriceListCode = PriceListCode;
        this.ProductNr = (ProductNr | 0);
        this.ShowDisplayOnInvoice = ShowDisplayOnInvoice;
        this.ContractTypePriceId = ContractTypePriceId;
        this.MainFeeTemplateNr = MainFeeTemplateNr;
        this.ReplaceWithContractTypeCode = ReplaceWithContractTypeCode;
    }
}

export function ContractTypeGeneral$reflection() {
    return record_type("Containers.ContractTypeGeneral.Model.ContractTypeGeneral", [], ContractTypeGeneral, () => [["Active", bool_type], ["ContractTypeCode", string_type], ["Display", string_type], ["Mortgage", Mortgage$reflection()], ["NContracts", int32_type], ["NetworkContractNr", option_type(int32_type)], ["PriceListCode", option_type(string_type)], ["ProductNr", int32_type], ["ShowDisplayOnInvoice", bool_type], ["ContractTypePriceId", option_type(int32_type)], ["MainFeeTemplateNr", option_type(int32_type)], ["ReplaceWithContractTypeCode", option_type(string_type)]]);
}

export class ContractTypeDetailsDTO extends Record {
    constructor(Display, ProductNr, PriceListCode, Active, ShowDisplayOnInvoice, NetworkContractNr, ContractTypePriceId, MainFeeTemplateNr, ReplaceWithContractTypeCode) {
        super();
        this.Display = Display;
        this.ProductNr = ProductNr;
        this.PriceListCode = PriceListCode;
        this.Active = Active;
        this.ShowDisplayOnInvoice = ShowDisplayOnInvoice;
        this.NetworkContractNr = NetworkContractNr;
        this.ContractTypePriceId = ContractTypePriceId;
        this.MainFeeTemplateNr = MainFeeTemplateNr;
        this.ReplaceWithContractTypeCode = ReplaceWithContractTypeCode;
    }
}

export function ContractTypeDetailsDTO$reflection() {
    return record_type("Containers.ContractTypeGeneral.Model.ContractTypeDetailsDTO", [], ContractTypeDetailsDTO, () => [["Display", option_type(string_type)], ["ProductNr", option_type(int32_type)], ["PriceListCode", option_type(string_type)], ["Active", option_type(bool_type)], ["ShowDisplayOnInvoice", option_type(bool_type)], ["NetworkContractNr", option_type(option_type(int32_type))], ["ContractTypePriceId", option_type(option_type(int32_type))], ["MainFeeTemplateNr", option_type(option_type(int32_type))], ["ReplaceWithContractTypeCode", option_type(option_type(string_type))]]);
}

export class GeneralTableViewModel extends Record {
    constructor(Name, Product, PricelistCode, Status, ContractTypeCode, NetworkContractNr, ContractTypePriceId) {
        super();
        this.Name = Name;
        this.Product = Product;
        this.PricelistCode = PricelistCode;
        this.Status = Status;
        this.ContractTypeCode = ContractTypeCode;
        this.NetworkContractNr = NetworkContractNr;
        this.ContractTypePriceId = ContractTypePriceId;
    }
}

export function GeneralTableViewModel$reflection() {
    return record_type("Containers.ContractTypeGeneral.Model.GeneralTableViewModel", [], GeneralTableViewModel, () => [["Name", string_type], ["Product", Product$reflection()], ["PricelistCode", option_type(string_type)], ["Status", string_type], ["ContractTypeCode", option_type(string_type)], ["NetworkContractNr", option_type(int32_type)], ["ContractTypePriceId", option_type(int32_type)]]);
}

export class Model extends Record {
    constructor(GlobalDependencies, ContractTypeCode, ContractTypeGeneral, ErrorMessage, IsEditingGeneralTable, GeneralTableViewModel, Pricelist) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractTypeCode = ContractTypeCode;
        this.ContractTypeGeneral = ContractTypeGeneral;
        this.ErrorMessage = ErrorMessage;
        this.IsEditingGeneralTable = IsEditingGeneralTable;
        this.GeneralTableViewModel = GeneralTableViewModel;
        this.Pricelist = Pricelist;
    }
}

export function Model$reflection() {
    return record_type("Containers.ContractTypeGeneral.Model.Model", [], Model, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractTypeCode", string_type], ["ContractTypeGeneral", ContractTypeGeneral$reflection()], ["ErrorMessage", option_type(string_type)], ["IsEditingGeneralTable", bool_type], ["GeneralTableViewModel", GeneralTableViewModel$reflection()], ["Pricelist", list_type(tuple_type(string_type, string_type))]]);
}

export class ContractTypeGeneralMsg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EditGeneralTableEvent", "LoadedPricelist", "LoadPricelist", "SavedContractTypeDetails", "DeleteContractType", "DeletedContractTypeDetails"];
    }
}

export function ContractTypeGeneralMsg$reflection() {
    return union_type("Containers.ContractTypeGeneral.Model.ContractTypeGeneralMsg", [], ContractTypeGeneralMsg, () => [[["Item", EditGeneralTableEvent$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), string_type], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", string_type]]])]], [["Item", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [ContractTypeDetailsDTO$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", ContractTypeDetailsDTO$reflection()]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]]]);
}

